// src/components/Home.js
import React, {useState} from 'react';
import ChangePasswordForm from "../components/ChangePassword/ChangePasswordForm";
import IMG from "../constants/image";
import {useNavigate} from "react-router-dom";
import {isMobile} from "react-device-detect";
import Account from "../components/AccountSetting/Account";

const AccountPage = () => {
    const [isChangePassword, setIsChangePassword] = useState(false);
    const navigate = useNavigate()

    const onBack = () => {
        navigate(-1)
    }

    const setChangePassword = () => {
        setIsChangePassword(true)
    }

    return (
        <div className='relative animate-fadeIn'>
            <div className='hidden md:flex flex-col justify-center items-center text-sm pb-4'>
                <div className='flex justify-center items-center gap-[5px] md:mb-5'>
                    <img className='' src={IMG.icon.setupGreen} alt="setupGreen"/>
                    <p className='text-sm md:text-xl font-bold'>Cài đặt tài khoản</p>
                </div>
                <p className='text-sm text-center px-10'>Thay đổi mật khẩu của bạn thường xuyên để tăng tính bảo mật</p>
            </div>
            {
                (isChangePassword || isMobile) ? <ChangePasswordForm setIsChangePassword={setIsChangePassword}/> :
                    <Account setChangePassword={setChangePassword}/>
            }
        </div>
    );
}

export default AccountPage;
